/*=========================================================================================
  File Name: moduleActivityMutations.js
  Description: Activity Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Felix MAsa
  
==========================================================================================*/

export default {
	ADD_ACTIVITY_ITEM(state, activity) {
		state.issues.unshift(activity);
	},
	SET_ISSUES(state, issues) {
		state.issues = issues === null || issues === undefined ? [] : issues;
	},
	REMOVE_MANUAL_DATA_ITEM(state, itemId) {
		const ItemIndex = state.issues.findIndex((p) => p.id === itemId);
		state.issues.splice(ItemIndex, 1);
	},
};
